// react
import { useState } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';

// material ui
import { Box, IconButton, Tooltip } from '@mui/material';

// relative
import ChatComponent from './ChatComponent';
import ChatDrawer from './ChatDrawer';

const aiSpinKeyframes = `
  @keyframes aiSpin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const AIAssistantAvatar = () => (
  <Box
    sx={{
      width: '40px',
      height: '40px',
      backgroundColor: '#212121',
      border: '1px solid hsl(0, 0%, 20%)',
      borderRadius: '35%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
    }}
  >
    <svg
      width="26"
      height="26"
      viewBox="0 0 40 40"
      style={{ animation: 'aiSpin 4s linear infinite' }}
    >
      <defs>
        <linearGradient id="ai_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="hsl(63, 100%, 20%)" />
          <stop offset="100%" stopColor="hsl(63, 100%, 70%)" />
        </linearGradient>
      </defs>
      <circle
        cx="20"
        cy="20"
        r="16"
        stroke="url(#ai_gradient)"
        strokeWidth="2"
        fill="none"
      />
    </svg>

    <style>{aiSpinKeyframes}</style>
  </Box>
);

export default function ChatButton() {
  const { t } = useTranslation('ai-assistant');
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title={t('aiLabel')} placement="bottom">
        <IconButton
          onClick={handleOpen}
          sx={{
            borderRadius: 2,
            // backgroundColor: alpha('#6495ED', 0.1),
            // ':hover': {
            //   backgroundColor: alpha('#6495ED', 0.2),
            // },
          }}
        >
          <AutoAwesomeOutlinedIcon />
        </IconButton>
      </Tooltip>

      <ChatDrawer
        open={open}
        onClose={handleClose}
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AIAssistantAvatar />
            <span>{t('title')}</span>
          </Box>
        }
        width={900}
        anchor="right"
      >
        <ChatComponent />
      </ChatDrawer>
    </>
  );
}
